import React, { useState } from "react";
import {
  Box,
  Button,
  Skeleton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import InspectionPanelListItem from "./components/InspectionPanelListItem";
import ConfirmDeleteInspectionDialog from "./components/ConfirmDeleteInspectionDialog/ConfirmDeleteInspectionDialog";
import { SystemFlagsEnum } from "../../../../../../models/session/system-flags.enum";
import ConfirmCleanSentList from "./components/ConfirmCleanSentList/ConfirmCleanSentList";

const InspectionPanelListNative = (props: any) => {
  const {
    showDeleteDialog,
    setShowDeleteDialog,
    waitingInspections = {},
    sentInspections = {},
    errorInspections = {},
    incompleteInspections = {},
    openDeleteDialog,
    deleteInspection,
    loading,
    showCleanSentDialog,
    setShowCleanSentDialog,
  } = props;
  const [value, setValue] = useState(0);
  const showList: boolean = (
    Object.keys(waitingInspections).length > 0
    || Object.keys(sentInspections).length > 0
    || Object.keys(errorInspections).length > 0
    || Object.keys(incompleteInspections).length > 0
  ) && !loading;

  const sentCount = Object.keys(sentInspections).length;
  const totalCount = new Set([
    ...Object.keys(waitingInspections),
    ...Object.keys(sentInspections),
    ...Object.keys(errorInspections),
    ...Object.keys(incompleteInspections),
  ]).size;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const uploadingInspectinoUnique = () => {
    const uniqId = localStorage
      .getItem(SystemFlagsEnum.SEND_INSPECTION_IDENTIFIER);

    return uniqId ? uniqId : 'no id';
  }

  return (
    <>
      {loading && (
        <Box
          sx={{
            padding: '20px',
            marginTop: '40px',
            width: '90%'
          }}
          data-testid="loading"
        >
          <Typography variant="h2"><Skeleton /></Typography>
          <Typography variant="h2"><Skeleton /></Typography>
          <Typography variant="h2"><Skeleton /></Typography>
        </Box>
      )}
      {(!showList && !loading) && (
        <Box
          sx={{
            fontSize: '14px',
            textAlign: 'center',
            marginTop: '60px',
          }}
          data-testid="empty-msg"
        >
          Parece que você não possui vistorias<br />cadastradas. Clique no botão abaixo<br />para começar uma vistoria.
        </Box>
      )}
      {showList && (
        <>
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              marginTop: '30px',
              marginBottom: '4px',
            }}
            data-testid="sent-counter"
          >
            <Box sx={{ flex: 1 }} />
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
              <Typography
                sx={{
                  color: '#ABABAB',
                  fontSize: '12px',
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                }}
              >{sentCount} de {totalCount}</Typography>
            </Box>
          </Box>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            sx={{ width: '100%' }}
            aria-label="inspections status tabs"
            className="primary-tab"
            data-testid="inspections-table"
          >
            <Tab label={"Aguardando envio"} />
            <Tab label="Enviadas" />
          </Tabs>
          {value === 0 && (
            <Box className='inspection-panel'>
              {errorInspections && Object.keys(errorInspections).map((key: string, index) => {
                return (
                  <InspectionPanelListItem
                    key={`error-${index}`}
                    inspectionSteps={errorInspections[key]}
                    openDeleteDialog={() => { openDeleteDialog(key) }}
                    editable={false}
                    hasError={true}
                  />
                )
              })}
              {incompleteInspections && Object.keys(incompleteInspections).map((key: string) => {
                return (
                  <InspectionPanelListItem
                    key={`incomplete-${key}`}
                    incomplete
                    atualUploadId={uploadingInspectinoUnique()}
                    inspectionSteps={incompleteInspections[key]}
                    openDeleteDialog={() => { openDeleteDialog(key) }}
                    hasError={false}
                  />
                )
              })}
              {waitingInspections && Object.keys(waitingInspections).map((key: string, index) => {
                return (
                  <InspectionPanelListItem
                    key={index}
                    editable
                    atualUploadId={uploadingInspectinoUnique()}
                    inspectionSteps={waitingInspections[key]}
                    openDeleteDialog={() => { openDeleteDialog(key) }}
                    hasError={false}
                  />
                )
              })}
            </Box>
          )}
          {value === 1 && (
            <Box className='inspection-panel'>
              {sentInspections && Object.keys(sentInspections).map((key: string, index) => {
                return (
                  <InspectionPanelListItem
                    key={index}
                    finished
                    inspectionSteps={sentInspections[key]}
                    openDeleteDialog={() => { openDeleteDialog(key) }}
                    hasError={false}
                  />
                )
              })}
            </Box>
          )}
        </>
      )}
      {(value === 1 && Object.keys(sentInspections).length > 0) && (
        <Box sx={{
          width: '100%',
          marginBottom: '0px !important',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex'
        }}>
          <Button
            sx={{
              marginBottom: '0px !important',
              textTransform: 'none',
              color: '#3C3B3B !important',
              fontWeight: '400 !important',
              fontSize: '14px !important',
              lineHeight: '21px !important',
              fontFamily: '"Poppins" !important',
            }}
            onClick={() => { setShowCleanSentDialog(true) }}
          >Limpar lista de enviadas</Button>
        </Box>
      )}
      <ConfirmDeleteInspectionDialog
        open={showDeleteDialog}
        handleClose={() => { setShowDeleteDialog(false) }}
        deleteInspectionAction={deleteInspection}
      />
      <ConfirmCleanSentList
        open={showCleanSentDialog}
        handleClose={() => { setShowCleanSentDialog(false) }}
        keepIdentifiers={Object.keys(incompleteInspections)}
      />
    </>
  );
};

export default InspectionPanelListNative;
